import React, { useState } from 'react';
import { TIPOS_GROUPED, ORIENTACIONES } from '../data/orientaciones';
import OrientacionPanel from '../components/OrientacionPanel';
import ColegioSelector from '../components/ColegioSelector';
import { doc, updateDoc } from 'firebase/firestore';
import { db } from '../firebase';

const ROLES = ['Propietario / Titular','Director(a) docente','Secretario(a) docente','Padre / Madre / Tutor','Estudiante','Personal administrativo','Otro'];

export default function EditarCaso({ caso, onGuardar, onCancel }) {
  const [form, setForm] = useState({ codigoCentro:caso.codigoCentro||'', centro:caso.centro||'', solicitante:caso.solicitante||'', rol:caso.rol||ROLES[0], telefono:caso.telefono||'', email:caso.email||'', fecha:caso.fecha||new Date().toISOString().split('T')[0], tipo:caso.tipo||'', descripcion:caso.descripcion||'', destinatario:caso.destinatario||'', estado:caso.estado||'Recibido', fechaAlerta:caso.fechaAlerta||'' });
  const [esNuevo, setEsNuevo] = useState(caso.codigoCentro==='NUEVO'||!caso.codigoCentro);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);
  const set = (k,v) => setForm(f=>({...f,[k]:v}));

  async function handleSubmit(e) {
    e.preventDefault();
    if ((!form.codigoCentro&&!esNuevo)||(esNuevo&&!form.centro)||!form.solicitante||!form.tipo) {
      setError('Completa los campos obligatorios.'); return;
    }
    setSaving(true); setError('');
    try {
      await updateDoc(doc(db,'casos',caso.id),{ ...form, editadoEn:new Date().toISOString() });
      setSuccess(true);
      setTimeout(()=>{ if(onGuardar) onGuardar(); },1200);
    } catch { setError('Error al guardar los cambios.'); }
    setSaving(false);
  }

  return (
    <div>
      <div style={{ marginBottom:14, display:'flex', gap:10, alignItems:'center' }}>
        <button className="btn btn-sm" onClick={onCancel}>← Volver</button>
        <span style={{ background:'linear-gradient(135deg,#b57a00,#F5A623)',color:'#fff',fontSize:11,fontWeight:700,padding:'3px 10px',borderRadius:20 }}>Editando caso</span>
      </div>
      <div className="card" style={{ maxWidth:760 }}>
        <div className="card-header"><h3>Editar caso — {caso.centro}</h3></div>
        <div className="card-body">
          {error&&<div style={{ background:'var(--red-light)',border:'1px solid #fca5a5',borderRadius:8,padding:'10px 14px',fontSize:13,color:'var(--red)',marginBottom:16 }}>{error}</div>}
          {success&&<div style={{ background:'#f0fdf4',border:'1px solid #86efac',borderRadius:8,padding:'10px 14px',fontSize:13,color:'#15803d',marginBottom:16,fontWeight:600 }}>✓ Caso actualizado correctamente. Redirigiendo...</div>}
          <form onSubmit={handleSubmit}>
            <div className="form-row">
              <div className="form-group">
                <label>Colegio *</label>
                <ColegioSelector value={form.codigoCentro} nombreValue={form.centro} esNuevo={esNuevo}
                  onToggleNuevo={v=>{setEsNuevo(v);setForm(f=>({...f,codigoCentro:'',centro:''}));}}
                  onChange={(codigo,nombre)=>setForm(f=>({...f,codigoCentro:codigo,centro:nombre}))}
                />
              </div>
              <div className="form-group"><label>Fecha *</label><input type="date" value={form.fecha} onChange={e=>set('fecha',e.target.value)}/></div>
            </div>
            <div className="form-row">
              <div className="form-group"><label>Solicitante *</label><input value={form.solicitante} onChange={e=>set('solicitante',e.target.value)}/></div>
              <div className="form-group"><label>Rol</label><select value={form.rol} onChange={e=>set('rol',e.target.value)}>{ROLES.map(r=><option key={r}>{r}</option>)}</select></div>
            </div>
            <div className="form-row">
              <div className="form-group"><label>Teléfono</label><input value={form.telefono} onChange={e=>set('telefono',e.target.value)}/></div>
              <div className="form-group"><label>Correo</label><input type="email" value={form.email} onChange={e=>set('email',e.target.value)}/></div>
            </div>
            <div className="form-group">
              <label>Tipo de caso *</label>
              <select value={form.tipo} onChange={e=>{set('tipo',e.target.value);if(ORIENTACIONES[e.target.value])set('destinatario',ORIENTACIONES[e.target.value].encargado);}}>
                <option value="">— Seleccionar —</option>
                {TIPOS_GROUPED.map(g=><optgroup key={g.group} label={g.group}>{g.options.map(o=><option key={o.value} value={o.value}>{o.label}</option>)}</optgroup>)}
              </select>
            </div>
            <div className="form-group"><label>Descripción</label><textarea value={form.descripcion} onChange={e=>set('descripcion',e.target.value)}/></div>
            <div className="form-row">
              <div className="form-group"><label>Enviado a</label><input value={form.destinatario} onChange={e=>set('destinatario',e.target.value)}/></div>
              <div className="form-group"><label>Estado</label><select value={form.estado} onChange={e=>set('estado',e.target.value)}><option>Recibido</option><option>En proceso</option><option>Orientado</option><option>Cerrado</option></select></div>
            </div>
            <div className="form-group" style={{ maxWidth:280 }}><label>Fecha límite</label><input type="date" value={form.fechaAlerta} onChange={e=>set('fechaAlerta',e.target.value)}/></div>
            {form.tipo&&<OrientacionPanel tipo={form.tipo}/>}
            <div style={{ display:'flex', gap:10, marginTop:16 }}>
              <button type="submit" className="btn btn-primary" disabled={saving||success}>{saving?'Guardando...':success?'✓ Guardado':'Guardar cambios'}</button>
              <button type="button" className="btn" onClick={onCancel}>Cancelar</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}
